import { createTheme } from "../utils/create-theme";
export var TRIBE_THEME = createTheme('tribe', {
  activeMode: 'light',
  light: {
    color: {
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primary: '#DE3931',
      secondary: '#FCB017',
      primaryDarker: '#b22e27',
      primaryLight: '#f5c4c1',
      primaryLighter: '#e5615a',
      primaryBright: '#D14433',
      primaryVeryLight: '#f5c4c1',
      link: '#DE3931',
      linkHover: '#000000',
      navigationActive: '#DE3931',
      accentDark: '#b22e27',
      accentLight: '#f5c4c1'
    }
  },
  dark: {
    color: {
      linkHover: '#53aeaa'
    }
  }
});
export default TRIBE_THEME;